// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2VOcf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2l2VE"};